import React, { useState } from "react";
import api from "../../../../../../api/axios";

const AddFacilites = ({ onAdded }) => {
  const [facilityName, setFacilityName] = useState("");

  const handleAddFacility = async (e) => {
    e.preventDefault();
    console.log("Form submitted with name:", facilityName);
    if (!facilityName) {
      return;
    }

    try {
      const payload = {
        name: facilityName,
        active: true,
      };

      const result = await api.post("/pms/amenities", payload);
      setFacilityName("");
      if (onAdded) onAdded();
    } catch (error) {
      console.error("Add facility failed:", error);
    }
  };
  return (
    <div
      className="modal fade"
      id="add-facilites"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">Add Room Facilites</h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form onSubmit={handleAddFacility}>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label text-muted">Facility Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter facility name"
                  value={facilityName}
                  onChange={(e) => setFacilityName(e.target.value)}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="submit" className="btn btn-primary">
                Save changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddFacilites;
